import { useMemo, useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { ADMIN_EMAIL } from '../../config';
import { auth } from '../../firebase';

function AdminLogin() {
  const [email, setEmail] = useState(ADMIN_EMAIL);
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const canSubmit = useMemo(() => {
    const e = String(email || '').trim();
    return e.includes('@') && String(password || '').length >= 6 && !loading;
  }, [email, loading, password]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    const emailToUse = String(email || '').trim();
    if (!password) {
      setStatus('Password is required.');
      return;
    }

    setLoading(true);
    setStatus('Signing in…');

    try {
      await signInWithEmailAndPassword(auth, emailToUse, password);
      setStatus('Signed in.');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Admin login failed', err);
      setStatus('Login failed. Check username/password and Firebase Auth settings.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="content-card" aria-label="Admin login">
      <div className="content-card-header">
        <div>
          <div className="section-title">Admin</div>
          <h1 className="section-subtitle">Login</h1>
        </div>
      </div>

      <form onSubmit={onSubmit} className="mini-list admin-form" style={{ marginTop: 12 }}>
        <div className="mini-item">
          <label className="mini-label" htmlFor="admin-email">
            Email
          </label>
          <input
            id="admin-email"
            className="text-input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@domain.com"
          />
        </div>

        <div className="mini-item">
          <label className="mini-label" htmlFor="admin-password">
            Password
          </label>
          <input
            id="admin-password"
            className="text-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </div>

        <div className="tip-form-actions" style={{ marginTop: 6 }}>
          <button type="submit" className="cta-button" disabled={!canSubmit}>
            <span>{loading ? '…' : '→'}</span> {loading ? 'Logging in…' : 'Login'}
          </button>
        </div>
      </form>

      {status && (
        <p className="secondary-text" style={{ marginTop: 10 }}>
          {status}
        </p>
      )}
    </section>
  );
}

export default AdminLogin;


